import { getDefaultActivityEmailLayout } from "./getActivityEmailLayouts";

const doesEmailActivityLayoutHaveRequiredFields = (): boolean => {
  return !!getDefaultActivityEmailLayout()?.schema.some(
    ({ field, required }) =>
      !["assigneeId", "crmActivityTypeId", "divider", "name"].includes(field) && required
  );
};
export default doesEmailActivityLayoutHaveRequiredFields;
